import InitializeContext from "context/initialize-context";
import moment from "jalali-moment";
import { memo, useContext, useMemo, useState } from "react";
import ChartBoxSkeleton from "components/skeleton/chart-box";
import TinyListSkeleton from "components/skeleton/tiny-list";
import ChartLine from "components/shared/charts/line";
import contentStatuses from "constants/content-statuses";

const Content = props => {
    const { loading, data, userType } = props;
    const enums = useContext(InitializeContext);
    const [activeForm, setActiveForm] = useState(enums.data.forms[0].id);

    const statuses = useMemo(() => {
        return enums.data.forms.map(form => ({
            title: form.title,
            value: form.id
        }));
        // eslint-disable-next-line
    }, [])

    const chartData = useMemo(() => {
        const counts = [];
        const days = [];

        if (!loading && !data.error && data.data?.content?.graph_last_month[activeForm])
            data.data.content.graph_last_month[activeForm].forEach(el => {
                counts.push(el.count);
                days.push(moment.unix(el.day).format("jYYYY/jMM/jD"));
            })

        return {
            counts,
            days
        }

        // eslint-disable-next-line
    }, [loading, data])

    const activeFormLabel = useMemo(() => {
        const intendedForm = enums.data.forms.find(form => form.id === parseInt(activeForm));
        return intendedForm ? intendedForm.title : "";
        // eslint-disable-next-line
    }, [activeForm])

    return (
        <div className="grid grid-cols-12 gap-4 mb-4">
            <div className="col-span-full lg:col-span-8">
                {
                    !loading ? (
                        !data.error ? (
                            <div className="wrap-box tp-22 page-transition">
                                <h2 className="tp-34 text-sm font-bold pb-4">نمودار ایجاد محتویات {userType === "user" ? "کاربر" : "تامین کننده"}</h2>

                                <div className="pt-3">
                                    <label className="select-c1 mb-8">
                                        <span>فرم انتخاب شده</span>

                                        <select onChange={e => setActiveForm(e.target.value)} value={activeForm}>
                                            {
                                                statuses.map(status => (
                                                    <option key={`option-${status.value}`} value={status.value}>{status.title}</option>
                                                ))
                                            }
                                        </select>
                                    </label>

                                    <ChartLine series={[{ name: 'تعداد', data: chartData.counts }]} xaxis={chartData.days} />
                                </div>
                            </div>
                        ) : <p className="text-red-500 text-xs">خطای سیستم!</p>
                    ) : <ChartBoxSkeleton />
                }
            </div>

            <div className="col-span-full lg:col-span-4">
                {
                    !loading ? (
                        !data.error ? (
                            <div className="wrap-box tp-22 page-transition">
                                <div className="state-box h-full flex flex-col">
                                    <h2 className="tp-34 text-sm font-bold pb-4">وضعیت محتویات ({activeFormLabel})</h2>

                                    <div className="overflow-auto spec-sb-c2">
                                        <ul>
                                            {
                                                contentStatuses.map((status, i) => (
                                                    <li key={`content-status-${i}`}>
                                                        <div>
                                                            <span className="sec-title tp-34">{status.title}</span>
                                                        </div>

                                                        <b className="tp-34">
                                                            {data.data?.content?.status[activeForm] ? data.data?.content?.status[activeForm][i] || 0 : 0}
                                                        </b>
                                                    </li>
                                                ))
                                            }

                                        </ul>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="wrap-box tp-22 page-transition">
                                <p className="global-error">خطا در دریافت اطلاعات !</p>
                            </div>
                        )
                    ) : <TinyListSkeleton />
                }
            </div>
        </div>
    )
}

export default memo(Content);